import { Component, EventEmitter, Input, Output } from '@angular/core';
var BsDatepickerMonthViewComponent = (function () {
    function BsDatepickerMonthViewComponent() {
        this.onSelect = new EventEmitter();
        this.onHover = new EventEmitter();
    }
    BsDatepickerMonthViewComponent.prototype.selectDay = function (event) {
        this.onSelect.emit(event);
    };
    BsDatepickerMonthViewComponent.prototype.hoverDay = function (event) {
        this.onHover.emit(event);
    };
    BsDatepickerMonthViewComponent.decorators = [
        { type: Component, args: [{
                    selector: "bs-datepicker-month-view",
                    // FIX: day select and hover should mutate day or use separate component
                    // changeDetection: ChangeDetectionStrategy.OnPush,
                    template: "\n    <table role=\"grid\" class=\"days weeks\">\n      <thead>\n      <tr>\n        <th *ngIf=\"options.showWeekNumbers\"></th><!--if show weeks-->\n        <th *ngFor=\"let weekday of month.weekdays; let i = index\"\n            aria-label=\"weekday\">{{ month.weekdays[i] }}\n        </th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let week of month.weeks; let i = index\">\n        <td class=\"week\" *ngIf=\"options.showWeekNumbers\"><span>{{ month.weekNumbers[i] }}</span>\n        </td>\n        <td *ngFor=\"let day of week.days\" role=\"gridcell\">\n          <span bsDatepickerDayDecorator [day]=\"day\"\n               (onSelect)=\"selectDay($event)\"\n               (onHover)=\"hoverDay($event)\">{{ day.label }}</span>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  "
                },] },
    ];
    /** @nocollapse */
    BsDatepickerMonthViewComponent.ctorParameters = function () { return []; };
    BsDatepickerMonthViewComponent.propDecorators = {
        'month': [{ type: Input },],
        'options': [{ type: Input },],
        'onSelect': [{ type: Output },],
        'onHover': [{ type: Output },],
    };
    return BsDatepickerMonthViewComponent;
}());
export { BsDatepickerMonthViewComponent };
//# sourceMappingURL=bs-datepicker-month-view.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/themes/bs/bs-datepicker-month-view.component.js
// module id = 872
// module chunks = 103